import React from 'react';
import Dialog from 'material-ui/Dialog';

const ContextDialog = ({ children, ...props }) => {
    return <Dialog {...props}>{children}</Dialog>;
};

export default React.memo(ContextDialog);
